<template>
  <div class="basic-info">
    <ul-form ref="basicInfo" :model="infoForm" :rules="rules" label-width="80px">
      <ul-form-item label="课程名称" prop="name">
        <ul-input v-model="infoForm.name" placeholder="请输入课程名称"></ul-input>
      </ul-form-item>
      <ul-form-item label="课程简介" prop="introduce" v-if="virtual.type == 1">
        <Editor
          v-model="infoForm.introduce"
          @onChange="changeText"
          :height="220"
          placeholder="请输入课程简介"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item label="课程封面">
        <label class="uploading" for="avatar">上传封面</label>
        <input
          v-show="false"
          type="file"
          id="avatar"
          style="position: absolute; clip: rect(0 0 0 0)"
          accept="image/png, image/jpeg, image/gif, image/jpg"
          @change="uploadImg($event)"
        />
        <span class="hint">建议尺寸：800*450</span>
        <img class="cover" :src="infoForm.cover || homePage">
      </ul-form-item>
      <ul-form-item label="课程学时" prop="studytime">
        <ul-input
          class="score-input"
          v-model="infoForm.studytime"
          placeholder="请输入学时"
          type="number"
        />
        <span class="hint">学时</span>
      </ul-form-item>
      <ul-form-item label="适合学段" prop="academic" v-if="virtual.type == 2">
        <ul-input class="text-input" v-model="infoForm.academic" placeholder="请输入适合学段"></ul-input>
      </ul-form-item>
      <ul-form-item label="负责教师" prop="teacher" v-if="virtual.type == 1">
        <ul-input class="text-input" v-model="infoForm.teacher" placeholder="请输入教师姓名"></ul-input>
      </ul-form-item>
      <ul-form-item label="学校" prop="school" v-if="virtual.type == 1">
        <ul-autocomplete
          class="text-input"
          v-model="infoForm.school"
          :fetch-suggestions="querySearch"
          :value-key="'orgName'"
          placeholder="请输入学校名称"
          :trigger-on-focus="false"
          @select="handleSelect"
        ></ul-autocomplete>
      </ul-form-item>
      <ul-form-item label="适合专业" prop="speciality"  v-if="virtual.type == 1">
        <ul-input class="text-input" v-model="infoForm.speciality" placeholder="请输入适合专业"></ul-input>
      </ul-form-item>
      <ul-form-item label="课程简介" prop="introduce" v-if="virtual.type == 2">
        <Editor
          v-model="infoForm.introduce"
          @onChange="changeText"
          :height="220"
          placeholder="请输入课程简介"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item label="课程目标" prop="teachTarget" v-if="virtual.type == 2">
        <Editor
          v-model="infoForm.teachTarget"
          @onChange="changeTargetText"
          :height="220"
          placeholder="请输入课程目标"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item label="课程内容" prop="teachContent" v-if="virtual.type == 2">
        <Editor
          v-model="infoForm.teachContent"
          @onChange="changeContentText"
          :height="220"
          placeholder="请输入课程内容"
        >
        </Editor>
      </ul-form-item>
      <ul-form-item label="预期效果" prop="effect" v-if="virtual.type == 2">
        <Editor
          v-model="infoForm.effect"
          @onChange="changeEffectText"
          :height="220"
          placeholder="请输入预期效果"
        >
        </Editor>
      </ul-form-item>
    </ul-form>
    <div class="line"></div>
    <ul-button type="primary" @click="save">保存</ul-button>
    
    <cropper ref="cropperDialog" @upData="upDataPicurl"></cropper>
  </div>
</template>

<script>
import Editor from 'pc/components/editor.vue'
import cropper from './components/cropper.vue'
import homePage from '@/assets/images/virtual/homePage.png'
import { saveCourseInfo, getCourseInfo } from '@/api/courseApi/virtual.js'
import { getAllOrgan } from '@/api/courseApi/index.js'
import { wordCount } from '@/utils/index'
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    Editor,
    cropper
  },
  computed: {
    ...mapGetters("virtual", { virtual: "virtual" }),
    courseId () {
      return this.$route.params.id
    },
    rules() {
      var validateRequest = (rule, value, callback) => {
        if (wordCount(value) > 10000) {
          callback(new Error('课程简介最多10000字'));
        } else {
          callback();
        }
      }
      let rules = {
        name: [
          { required: true, message: '请输入课程名称', trigger:"blur" },
          { max: 50, message: '课程名称最多50字', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '请输入课程简介', trigger:"blur" },
          { validator: validateRequest, trigger: 'blur' },
        ],
        cover: [
          { required: true, message: '请上传封面', trigger:"blur" },
        ],
        studytime: [
          { required: true, message: '请输入学时', trigger:"blur" },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur'}
        ],
        teacher: [
          { required: true, message: '请输入教师姓名', trigger:"blur" },
        ],
        academic: [
          { required: true, message: '请输入适合学段', trigger:"blur" },
        ],
        school: [
          { required: true, message: '请输入学校名称', trigger:"blur" },
        ],
        speciality: [
          { required: true, message: '请输入适合专业', trigger:"blur" },
        ]
      }
      return rules
    },
  },
  data() {
    return {
      homePage,
      infoForm: {
        id: this.$route.params.id,
        name: '',
        introduce: '',
        cover: '',
        studytime: '',
        teacher: '',
        school: '',
        speciality: ''
      },
      restaurants: []
    }
  },
  created() {
    window.test = this
    getAllOrgan()
    .then(res=>{
      this.restaurants = res
    })
  },
  mounted() {
    console.log('-------' + this.virtual.name);
    this.infoForm = JSON.parse(JSON.stringify(this.virtual))
  },
  methods: {
    ...mapActions("virtual", ["setVirtual"]),
    courseInfo() {
      getCourseInfo({courseId: this.courseId})
      .then(({result})=>{
        this.setVirtual(result)
      })
    },
    save() {
      this.$refs.basicInfo.validate((valid)=>{
        if (valid) {
          saveCourseInfo(this.infoForm)
          .then(res => {
            this.courseInfo()
            this.$message({
              message: '保存成功',
              type: 'success'
            })
          })
        }
      })
    },
    changeText(text) {
      this.infoForm.introduce = text
    },
    changeTargetText(text) {
      this.infoForm.teachTarget = text
    },
    changeContentText(text) {
      this.infoForm.teachContent = text
    },
    changeEffectText(text) {
      this.infoForm.effect = text
    },
    uploadImg(e) {
      let data = {
        title: '上传封面'
      }
      this.$refs.cropperDialog.uploadImg(e, data)
    },
    upDataPicurl(url) {
      this.$set(this.infoForm, 'cover', url)
    },
    handleSelect(item) {
      console.log(item);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.orgName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
  }
}
</script>

<style lang="scss" scoped>
.basic-info {
  padding-top: 32px;
  .line {
    border-top: 1px dashed #E3E3E9;
    margin: 20px 0;
  }
  .score-input {
    width: 110px;
    margin-right: 10px;
  }
  .hint {
    color: #969696;
  }
  .uploading {
    color: #8D77FB;
    cursor: pointer;
    margin-right: 12px;
  }
  .cover {
    display: block;
    width: 208px;
  }
  .text-input {
    width: 380px;
  }
}
</style>